import { ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';
import * as fromStatic from './static.reducer';

export interface State {
  [fromStatic.staticFeatureKey]: fromStatic.State;
}

export const reducers: ActionReducerMap<State> = {
  [fromStatic.staticFeatureKey]: fromStatic.reducer,
};

export function stateSetter(reducer: ActionReducer<any>): ActionReducer<any> {
  return (state: any, action: any) => {
    if (action.type === 'SET_ROOT_STATE') {
      return action.payload;
    }
    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<State>[] = [];
